import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import { Brand } from '../../../business-entities/brand.model';
import { AddCheckListRequestModel } from '../../../business-entities/dwo-check-list-group-mapping-view-model';
import { CheckListBymappingId, DwoCheckListRequestModel } from '../../../business-entities/dwo-check-list-request-model';
import { DwoSubCheckListDetailViewModel } from '../../../business-entities/dwo-sub-check-list-detail-view-model';
import { DwoSubCheckListViewModel } from '../../../business-entities/dwo-sub-check-list-view-model';
import { GenericResponse } from '../../../business-entities/generic-response';
import { VehicleType } from '../../../business-entities/vehicleTypes-model';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { CheckListBusinessService } from './../../../business-services/check-list.service';
import * as fromenums from './../../../../../../Autofacets-Core/src/app/utils/enums'
import { AddMulticplourChecklistItemComponent } from '../add-multicplour-checklist-item/add-multicplour-checklist-item.component';

@Component({
  selector: 'app-add-check-list',
  templateUrl: './add-check-list.component.html',
  styleUrls: ['./add-check-list.component.css']
})
export class AddCheckListComponent implements OnInit {
  language: string
  addCheckListForm: FormGroup;
  vehicleType: VehicleType[];
  vehicleTypeList: VehicleType[] = [];
  brandList: Brand[] = [];
  brand: Brand[];
  genericVehicleType: VehicleType = { id: 0, name: "All Vehicle Types", code: "ALL", isDisplay: true };
  checkListId: number;
  multiColor: boolean = false;
  duplicateChecklist: boolean = false;
  condition: boolean = false;
  isMulticlr: boolean = false;
  radioValue: string;
  checkList: DwoSubCheckListViewModel[];
  checkListByMapping: CheckListBymappingId[] = [];
  checkListByMappingId: CheckListBymappingId[] = [];
  currentUser: string
  languageList: any[];
  vehicletypeName: string;
  isShowCheckListType: boolean = false;
  checkListtypeValue : number;
  showPredefinedChecklist : boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private cookieservice: CookieService,
    private baseService: BaseService,
    private modalService: NgbModal,
    private getAllBrandData: RentalCarService,
    private checkListBusinessService: CheckListBusinessService,
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.showPredefinedChecklist = this.checkListBusinessService.showPredefinedChecklist;
    this.languageList = this.currentLanguageService.LanguageList;
    this.checkListBusinessService.isEdit = true;
    this.isMulticlr = this.checkListBusinessService.multiColorSelect;
    this.radioValue = "";
    this.addCheckListForm = this.formBuilder.group({
      service: new FormArray([]),
      colorcheckListType:[''],
      sequence: ['', [Validators.min(1), Validators.max(99),Validators.required]],
      brandId: [null, [Validators.required]],
      vehicleTypeId: ['', [Validators.required]],
      isActive: [true],
      isMulticolorCheckListSelected: [this.multiColor],
      twoColor: [''],
    });
    this.getLanguage();
    this.getBrandData();
    this.getVehicleData();
    this.checkListId = this.checkListBusinessService.checkListId;
    this.duplicateChecklist = this.checkListBusinessService.duplicateChecklist;
    if (this.checkListId > 0) {
      if(!this.duplicateChecklist){
        this.condition = true;
        this.getCheckListByMappingId(this.checkListId);       
        this.addCheckListForm.controls['twoColor'].disable();
      }  
      else if(this.duplicateChecklist && this.checkListBusinessService.multiColorSelect){
        this.addCheckListForm.patchValue({
          isMulticolorCheckListSelected: true,
          duplicateChecklist: this.duplicateChecklist,
        })
      } 
      this.addCheckListForm.controls['isMulticolorCheckListSelected'].disable();
    }
    this.addCheckListForm.controls['colorcheckListType'].disable();
  }
  OnClose() {
    this.activeModal.close({ success: false });
    
  }
  get cpf() {
    return this.addCheckListForm.controls;
  }
  get t() { return this.cpf.service as FormArray; }
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
  }
  async getBrandData() {
    await this.GetAllBrand();
  }
  async getVehicleData() {
    await this.GetAllVehicleType();
  }
  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand){
        this.brandList.push(value)
      }
    })
  }
  async GetAllVehicleType() {
    this.vehicleTypeList.push(this.genericVehicleType);
    await this.checkListBusinessService.getVehicleTypes().then(data => {
      this.vehicleType = data.responseObject.filter(x => x.isDisplay);
      for (let value of this.vehicleType) {
        this.vehicleTypeList.push(value)
      }
    })
  }
  getCheckList(param: DwoCheckListRequestModel) {
    this.spinner.show();
    this.checkListBusinessService.getCheckList(param).then((response: GenericResponse<DwoSubCheckListDetailViewModel>) => {
      this.checkList = response.responseObject.dwoSubCheckList;
    });
  }
  getCheckListByMappingId(id: number) {
    let viewModel =
    {
      MappingId: id,
      LanguageCode: this.cookieservice.get('userSelectedLanguage')
    }
    this.checkListBusinessService.getCheckListByMappingId(viewModel).then((response) => {
      this.addCheckListForm.reset();
      if (response.responseCode === 200 && response.responseObject.errorCount === undefined) {
        if (response.responseObject !== undefined && response.responseObject !== null) {
          if (response.responseObject.checkListByMappingId[0].colourCheckListType > 0) {
            this.isShowCheckListType  = true;
            this.checkListtypeValue = response.responseObject.checkListByMappingId[0].colourCheckListType;
          }
          else{
            this.isShowCheckListType  = false;
          }
          this.radioValue = response.responseObject.checkListByMappingId[0].colourCheckListType;
          this.addCheckListForm.patchValue({
            sequence: response.responseObject.checkListByMappingId[0].sequence,
            colorcheckListType : response.responseObject.checkListByMappingId[0].colourCheckListType + ' Colour',
            brandId: response.responseObject.checkListByMappingId[0].brandId,
            vehicleTypeId: response.responseObject.checkListByMappingId[0].vehicleTypeId,
            isActive: response.responseObject.checkListByMappingId[0].isActive,
            service: response.responseObject.checklistDetails,
            isMulticolorCheckListSelected: response.responseObject.checkListByMappingId[0].isMulticolorCheckListSelected,
            duplicateChecklist: this.duplicateChecklist,
            twoColor: this.radioValue.toString()
          })
        }
      }
    });
  }
  onSubmit() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.addCheckListForm?.value) {
      if (this.addCheckListForm.value.service && this.addCheckListForm.value.service.length === number && this.addCheckListForm.value.sequence?.toString().trim()) {
        let title = this.addCheckListForm.value.service.map(x => {
          if (!x.name?.trim()) {
            return x;
          }
          else {
            x.name = x.name.trim()
          }
        });
        if (title && title.length > 0) {
          let validTitle = title.filter(x => x !== undefined)
          if (validTitle && validTitle.length > 0) {
            let msg = this.translate.instant("lblPleaseEnterValidValue");
            this.toastr.error(msg)
          }
          else {
            this.CheckListItem();
          }
        }
        else {
          this.CheckListItem();
        }
      }
      else {
        let msg = this.translate.instant("lblPleaseEnterValidValue");
        this.toastr.error(msg)
      }
    }


  }
  
  CheckListItem() {
    this.currentUser = '';
    if (this.addCheckListForm.value.sequence === "") {
      this.addCheckListForm.controls.sequence.setValue(0);
    }
    let checkListSubmitForm: AddCheckListRequestModel = {
      parentId: 0,
      clType: fromenums.ClType.Generic,
      sequence: Number(this.addCheckListForm.value.sequence),
      isActive: this.addCheckListForm.value.isActive,
      brandId: this.addCheckListForm.value.brandId,
      vehicleTypeId: this.addCheckListForm.value.vehicleTypeId,
      lnlnvalue: this.addCheckListForm.value.service,
      isMulticolorCheckListSelected : this.addCheckListForm.value.isMulticolorCheckListSelected,
      colorCheckListType : this.radioValue,
    }
    this.currentUser = '';
    this.spinner.show();
    if (this.checkListId > 0 && !this.duplicateChecklist) {
      let viewModel = {
        sequence: Number(this.addCheckListForm.value.sequence),
        isActive: this.addCheckListForm.value.isActive,
        brandId: this.addCheckListForm.value.brandId,
        vehicleTypeId: this.addCheckListForm.value.vehicleTypeId,
        lnlnvalue: this.addCheckListForm.value.service,
        isMulticolorCheckListSelected : this.addCheckListForm.value.isMulticolorCheckListSelected,
        mappingId: this.checkListId
      }
      this.checkListBusinessService.updateCheckList(viewModel).then((response: GenericResponse<any>) => {
        if (response.responseObject) {
          let successMsg = this.translate.instant("lblCheckListUpdated");
          this.toastr.success(successMsg);
        }
        this.activeModal.close({
          success: true
        });
        this.spinner.hide();
      });
    }
    else if (this.checkListId > 0 && this.duplicateChecklist) {
      let viewModel = {
        sequence: Number(this.addCheckListForm.value.sequence),
        isActive: this.addCheckListForm.value.isActive,
        brandId: this.addCheckListForm.value.brandId,
        vehicleTypeId: this.addCheckListForm.value.vehicleTypeId,
        lnlnvalue: this.addCheckListForm.value.service,
        mappingId: this.checkListId,
        isMulticolorCheckListSelected : this.checkListBusinessService.multiColorSelect,
        duplicateChecklist: this.duplicateChecklist,
        colourChecklistType: this.radioValue,
      }
      this.checkListBusinessService.createDuplicateCheckList(viewModel).then((response: GenericResponse<any>) => {
        if (response.responseObject) {
          let successMsg = this.translate.instant("lblCheckListAdded");
          this.toastr.success(successMsg);
        }
        this.activeModal.close({
          success: true
        });
        this.spinner.hide();
      });
    }
    else {
      this.checkListBusinessService.addCheckList(checkListSubmitForm).then((_response: GenericResponse<any>) => {
        let successMsg = this.translate.instant("lblCheckListAdded");
        this.toastr.success(successMsg);
        this.activeModal.close({
          success: true
        });
        this.spinner.hide();
      });
    }
  }

  onShow() {
    this.isMulticlr = !this.isMulticlr;
    this.radioValue = "";
    this.addCheckListForm.controls['twoColor'].reset()
  }


  OpenItem() {
    const modalref = this.modalService.open(AddMulticplourChecklistItemComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  onChange(event: any) {
    this.radioValue = event.target.value;
  }

}
